import React from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  deselectAllSubmissionDefaultColumns,
  deselectSubmissionColumn,
  orderedSubmissionColumns,
  selectAllSubmissionDefaultColumns,
  selectSubmissionColumn,
  submissionColumnOptions,
} from "reduxSlices/reportBuilderSlice"
import MassSelection from "shared/MassSelection"
import ColumnOption from "../ColumnOption"

const SubmissionDefaultColumnOptions = () => {
  const dispatch = useDispatch()
  const subColumnOptions = useSelector(submissionColumnOptions)

  const selectedSubmissionColumns = useSelector(orderedSubmissionColumns)

  const deselectAll = () => dispatch(deselectAllSubmissionDefaultColumns())
  const selectAll = () => dispatch(selectAllSubmissionDefaultColumns())

  const addOption = (column) => dispatch(selectSubmissionColumn(column))
  const undoMove = (column) => dispatch(deselectSubmissionColumn(column))

  return (
    <div>
      <div className="mb-1 text-xl">Submission Column Defaults</div>
      <MassSelection
        deselectAll={deselectAll}
        selectAll={selectAll}
      />
      <div className="w-full mt-4 space-y-2">
        {
          subColumnOptions.map((option) => (
            <ColumnOption
              key={`${option.type}-${option.id}`}
              option={option}
              selectedColumns={selectedSubmissionColumns}
              selectOption={addOption}
              deselectOption={undoMove}
            />
          ))
        }
      </div>
    </div>
  )
}

export default SubmissionDefaultColumnOptions
